import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionItemProps,
  AccordionPanel,
  AccordionPanelProps,
} from "@chakra-ui/react";
import { ReactNode, useEffect, useRef, useState } from "react";

import { RanaHeading } from "@nens/ranalib";

interface RanaAccordionItemProps extends AccordionItemProps {
  children?: ReactNode;
  title: string;
  onButtonClick?: () => void;
  accordionPanelProps?: AccordionPanelProps;
}

export function RanaAccordionItem({
  children,
  title,
  onButtonClick,
  accordionPanelProps,
  ...rest
}: RanaAccordionItemProps) {
  const panelRef = useRef<HTMLDivElement | null>(null);

  const disabled = !panelRef.current?.innerHTML;

  // We need to delay DISABLING the accordions otherwise it will throw a warning. But it should NOT delay ENABLING them otherwise it will also throw a warning
  const [disabledOnDelay, setDisabledOnDelay] = useState(false);
  useEffect(() => {
    setTimeout(() => setDisabledOnDelay(!panelRef.current?.innerHTML), 100);
  }, [children]);

  const actuallyDisabled = disabled && disabledOnDelay;

  return (
    <AccordionItem
      bg="brand.cloudy"
      borderWidth="base"
      my={4}
      _last={{ mb: 0 }}
      isDisabled={actuallyDisabled}
      rounded="base"
      {...rest}
    >
      <AccordionButton color="brand.clear_creek" onClick={onButtonClick} borderBottomWidth="base">
        <RanaHeading color="brand.clear_creek" type="h6" flex="1" textAlign="left">
          {title}
        </RanaHeading>
        <AccordionIcon />
      </AccordionButton>
      <AccordionPanel
        rounded="base"
        ref={panelRef}
        bg="brand.grey.100"
        py={4}
        {...accordionPanelProps}
      >
        {children}
      </AccordionPanel>
    </AccordionItem>
  );
}
